var SOHO = SOHO || {};

$(function(){

    jQuery.validator.addMethod("email", function(value, element) {
      return this.optional( element ) || /^\b[^@áàéèíìóòúù ]+@[a-zA-Z0-9]+\.[a-z][a-z\.]*[a-zA-Z]$\b/i.test(value);
    }, "Por favor ingresa un email válido");

    jQuery.validator.addMethod("phone", function(phone_number, element) {
      phone_number = phone_number.replace(/\s+/g, "");
      return this.optional(element) || phone_number.length > 11;
    }, "Por favor ingresa un celular válido");

    function filter_email (email) {
      var emailExp = new RegExp(/^\b[^@áàéèíìóòúù ]+@[a-zA-Z0-9]+\.[a-z][a-z\.]*[a-zA-Z]$\b/i);
      filtered = email.match(emailExp);
      return filtered ? filtered[0] : false;
    }

    function validaRut(rut) {
      /* var rutIsNum = false;
      $.validateRut(value, function(r, dv) {
        // esta función sólo se invoca si el RUT es válido
        rutIsNum = /^[^a-z]\d+$/.test(r);
      });
      return rutIsNum; */
      if (!rut) {
        return false
      }
      // Despejar Puntos
      let valor = rut.replace(/\./g, '')

      // Despejar Guión
      valor = valor.replace('-', '')

      // Aislar Cuerpo y Dígito Verificador
      let cuerpo = valor.slice(0, -1)
      let dv = valor.slice(-1).toUpperCase()

      // Formatear RUT
      rut = cuerpo + '-' + dv

      // Si no cumple con el mínimo ej. (n.nnn.nnn)
      if (cuerpo.length < 7) {
        return false
      }

      // Calcular Dígito Verificador
      let suma = 0
      let multiplo = 2

      // Para cada dígito del Cuerpo
      for (let i = 1; i <= cuerpo.length; i++) {
        // Obtener su Producto con el Múltiplo Correspondiente
        let index = multiplo * valor.charAt(cuerpo.length - i)

        // Sumar al Contador General
        suma = suma + index

        // Consolidar Múltiplo dentro del rango [2,7]
        if (multiplo < 7) {
          multiplo = multiplo + 1
        } else {
          multiplo = 2
        }
      }

      // Calcular Dígito Verificador en base al Módulo 11
      let dvEsperado = 11 - (suma % 11)

      // Casos Especiales (0 y K)
      dv = dv == 'K' ? 10 : dv
      dv = dv == 0 ? 11 : dv

      // Validar que el Cuerpo coincide con su Dígito Verificador
      if (dvEsperado != dv) {
        return false
      }

      // Si todo sale bien, eliminar errores (decretar que es válido)
      return true
    }

    jQuery.validator.addMethod("rut", function(value, element) {
      return this.optional(element) || validaRut(value);
    });

    $("input#rut").rut({formatOn: 'keyup', minimumLength: 11, validateOn: 'change keyup', ignoreControlKeys: false});

    $('input').on('focusout', function(){
      $(this).val($.trim($(this).val()));
    })

    //Add limit for 12 chars
    var input=  document.getElementById('rut');
    if (input) {
      input.addEventListener('input',function(){
        if (this.value.length > 12) 
          this.value = this.value.slice(0,12); 
      })
    }   

    function validateAndSendForm(formEl) {
        $(formEl).validate({
            lang: 'es',
            rules : {
                rut: { required: true, rut: true, minlength: 9, maxlength: 12 },
                email: { required: true, email: true, maxlength: 80 },
                phone: { required: true, phone: true },
                last_name: {
                    required: true,
                    maxlength: 80
                },
                first_name: {
                    required: true,
                    maxlength: 80
                },
            },
            messages : {
                rut : { required:'Escribe tu RUT', rut:'Por favor ingresa un RUT válido' },
                phone: { required: 'Escribe el celular de contacto', phone: 'Por favor ingresa un celular válido'},
            },
            submitHandler: function(form) {
              $(form).find('input[type=submit]').attr('disabled', true);
              $.ajax({
                type: 'POST',
                url: ajax_filter_params.ajax_url,
                dataType: 'json',
                data: $(form).serialize() + '&action=submit_ces_quotation_ajax',
                success: function(result) {
                  type = result.type;
                  quotation_id = result.id;
                  if(!result.error && quotation_id){
                    if (type === 'auto') {
                      window.location = '/comprobante?c=' + quotation_id;
                    }else{
                      window.location = '/comprobante-usado?c=' + quotation_id;
                    }
                  }                            
                },
                error: function(result){
                  $(form).find('input[type=submit]').attr('disabled', false);
                }
              });
              $(".submit-form-quotation, #submitCesQuotation").prop('value', 'Enviando Cotización');
            }
        });
    }

    //Active validator & ajax
    validateAndSendForm('#cesQuotationForm');
    
    //Triggers form single-version
    $('.submit-form-quotation').on('click', function(e){
      e.preventDefault();
      $('.extra-info').removeClass('d-none');
      $('#cesQuotationForm').submit();
    })

    $('#info-single-email').focus(function () {
      $('.extra-info').removeClass('d-none');
    })
});